import script from "./BrandFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandFormModal.vue?vue&type=script&setup=true&lang=js"

import "./BrandFormModal.vue?vue&type=style&index=0&id=03928cef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03928cef"]])

export default __exports__